// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/index.style.scss
// module id = 922
// module chunks = 1